import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';

export type ButtonType = 'submit' | 'button';

export type ButtonSizeType = 'sm' | 'md' | 'lg';

export type ButtonColorType =
  | 'success'
  | 'primary'
  | 'outline'
  | 'outline-secondary'
  | 'transparent'
  | 'outline-success'
  | 'outline-success-transparent'
  | 'danger';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [RouterLink],
})
export class ButtonComponent implements OnInit, OnChanges {
  @Input() public btnType: ButtonType = 'button';

  @Input() public title: string | undefined;

  @Input() public color: ButtonColorType = 'success';

  @Input() public size: ButtonSizeType = 'md';

  @Input() public disabled = false;

  @Input() public rounded = true;

  @Input() public scalped = false;

  @Input() public scalpedTop = false;

  @Input() public contentSpaceBetween = false;

  @Input() public btnClass: string | undefined;

  @Input() public btnTextClass: string | undefined;

  @Input() public spinner = false;

  @Input() public link: string[];

  @Output() btnClick = new EventEmitter<any>();

  public baseClassesArray: string[] = ['btn', 'lm-btn', 'no-transition'];

  public baseClasses: string = this.baseClassesArray.join(' ');
  public colorClasses = 'btn-success';
  public roundedClasses: string | undefined;
  public sizeClasses: string | undefined;
  public textClasses: string | undefined;
  public disableClasses: string | undefined;
  public btnClasses: string | undefined;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.setClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const colorHasChanged = changes.color?.previousValue !== changes.color?.currentValue;
    const disabledHasChanged = changes.disabled?.previousValue !== changes.disabled?.currentValue;

    if (colorHasChanged || disabledHasChanged) {
      this.setClasses();
    }
  }

  onClickButton(event: any): void {
    this.btnClick.emit(event);
  }

  setClasses(): void {
    switch (this.size) {
      case 'sm': {
        this.sizeClasses = 'btn-size-sm';
        this.textClasses = 'btn-text-small';
        break;
      }
      case 'lg': {
        this.sizeClasses = 'btn-size-lg';
        this.textClasses = 'btn-text-large';
        break;
      }
      case 'md':
      default: {
        this.sizeClasses = 'btn-size-md';
        this.textClasses = 'btn-text-base';
        break;
      }
    }

    if (this.contentSpaceBetween) {
      this.textClasses += ' btn-content-space-between';
    }

    if (this.scalped) {
      this.textClasses += ' scalped-border';
    }

    if (this.scalpedTop) {
      this.textClasses += ' scalped-border-alta';
    }

    if (this.rounded && this.color !== 'transparent') {
      this.roundedClasses = 'rounded-pill';
    } else {
      this.roundedClasses = 'rounded-md';
    }

    if (this.color === 'transparent') {
      this.colorClasses = '';
    } else if (this.color === 'outline-secondary') {
      this.colorClasses = 'btn-outline-secondary';
    } else if (this.color === 'outline-success-transparent') {
      this.colorClasses = 'btn-outline-success-transparent';
    } else if (this.color === 'outline-success') {
      this.colorClasses = 'btn-outline-success';
    } else if (this.color === 'danger') {
      this.colorClasses = 'btn-danger';
    } else if (this.color === 'primary') {
      this.colorClasses = 'btn-primary';
    } else {
      this.colorClasses = 'btn-success';
    }

    if (this.disabled) {
      this.disableClasses = 'disabled';
    } else {
      this.disableClasses = '';
    }

    if (this.btnClass) {
      this.btnClasses = this.btnClass;
    } else {
      this.btnClasses = '';
    }
  }
}
